import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';

/**
 * Implements theme management and provides the root layout for all pages.
 */
const App: React.FC = () => {
    return (
        <ThemeProvider>
            <Outlet />
        </ThemeProvider>
    );
};

export default App;